import Link from 'gatsby-link';
import React from 'react';

export default ({ categories }) => {
  if(categories.length === 0) { return null; }

  return(
    <p>
      KATEGORIEN<br/>
      {categories.map((category, index) =>
        <span key={category}>
          {index > 0 ? ', ' : null}
          <Link to={`/category/${category}/`}>
            {category}
          </Link>
        </span>
      )}
    </p>
  );
};



// WEBPACK FOOTER //
// ./src/components/categories.js